import { createFileRoute } from "@tanstack/react-router";
import { BlockRenderer } from "~/components/blocks";
import { loadStandalonePage } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/contact")({
  loader: async () => {
    const page = await loadStandalonePage({ data: { path: "contact/_index.md" } });
    return {
      title: (page.title as string) || "Contact C1",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      blocks: (page.blocks as any[]) || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: loaderData?.seo_title || loaderData?.title,
      description: loaderData?.seo_description || "",
      url: "/contact",
    }),
    links: seoLinks({ url: "/contact" }),
  }),
  component: ContactPage,
});

function ContactPage() {
  const page = Route.useLoaderData();
  return <BlockRenderer blocks={page.blocks} />;
}
